import { Box, Typography } from '@mui/material';
import React from 'react';
import { ITopic } from '../../../../store/TopicSlice';
import { ISubTopic } from '../../../../store/SubTopicSlice';

interface IExploreTopicsBarProps {
  subTopic: ISubTopic;
  topicData: ITopic;
}

const SubTopicVideoDescription: React.FC<IExploreTopicsBarProps> = ({
  subTopic,
  topicData,
}) => {
  return (
    <Box
      component="section"
      sx={{
        alignItems: 'center',
        borderRadius: '20px',
        zIndex: 5,
        backgroundColor: '#FFFFFF',
        p: '20px',
      }}
    >
      <Typography variant="subtitle1" fontSize="25px" fontWeight={700}>
        {subTopic.name} – {topicData.curriculum} {topicData.subject} Video
        Lesson
      </Typography>
      <Typography
        variant="subtitle1"
        fontSize="16px"
        mt="10px"
        fontWeight={400}
      >
        Watch this in-depth video lesson on {subTopic.name}, a key sub-topic
        under {topicData.name} in the {topicData.curriculum} {topicData.subject}{' '}
        syllabus. Understand essential concepts, all explained visually to help
        you to solve questions with confidence.
        <br /> 🎯 Developed by expert examiners to support your video-based{' '}
        {topicData.curriculum} {topicData.subject} revision and success.
      </Typography>
    </Box>
  );
};

export default SubTopicVideoDescription;
